/** @format */

import { useContext } from 'react';
import { CommonDispatcherContext } from 'providers';

function useCommonDispatcher() {
  return useContext(CommonDispatcherContext);
}

export { useCommonDispatcher };
